module.exports = __webpack_public_path__ + "static/img/XugarHero_warningHigh.2ae8f14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/brand/xugarhero/assets/xugarHero/XugarHero_warningHigh.svg
// module id = no8f
// module chunks = 1